import script from "./languageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./languageSelector.vue?vue&type=script&setup=true&lang=js"

import "./languageSelector.vue?vue&type=style&index=0&id=40eea798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40eea798"]])

export default __exports__